import React, { useEffect, useState } from 'react'

import { AwardContentSection } from '../AwardContentSection'
import { useRouter } from 'next/router'
import { LocationKey, LocationsKey } from '../../types/location'

type Props = {
  location?: LocationsKey
  isShares?: boolean
}

const RESKILLING_SOURCES: string[] = ['deca', 'lks']

export const AwardContent = ({ location, isShares }: Props) => {
  const [, setShowReskilling] = useState<boolean>(false)

  const router = useRouter()
  const isLocation = location && Object.values(LocationKey).includes(location)

  // NOTE: RESKILLING_SOURCESでの出し分けは2024年末時点では行わない方針となったが、
  //       CRMチームとの合意が取れていないため、コード上は残しておく
  useEffect(() => {
    if (router?.isReady) {
      const utm_source = router.query.utm_source
      if (RESKILLING_SOURCES.some(s => s === utm_source)) {
        setShowReskilling(true)
      }
    }
  }, [router])

  return (
    <>
      <section id="award-content" className="w-full bg-white">
        <AwardContentSection />
      </section>
    </>
  )
}
